import React, { useState } from "react";
import Swal from "sweetalert2";
import { submitChargingConfig } from "../../../../api/Api";
import { getFromLocalStorage } from "../../../../utils/common-utils";
import Loader from "../../../../components/loader/loader";
export default function ChargingConfigTabs({
  productId,
  setActiveTab,
  renewalType,
  onComplete
}) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [configData, setConfigData] = useState({
    renRetry: "",
    renRetryIntervalHour: "00",
    renRetryIntervalMin: "00",
    renStartHour: "00",
    renStartMin: "00",
    renStopHour: "23",
    renStopMin: "59",
    renNotifyStartHour: "00",
    renNotifyStartMin: "00",
    renNotifyEndHour: "23",
    renNotifyEndMin: "59",
  });

  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfigData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const payload = {
        id: productId,
        userId: getFromLocalStorage("userData")?.id,
        renewalType: renewalType,
        renRetry: configData.renRetry,
        renRetryIntervalHour: configData.renRetryIntervalHour,
        renRetryIntervalMin: configData.renRetryIntervalMin,
        renStartHour: configData.renStartHour,
        renStartMin: configData.renStartMin,
        renStopHour: configData.renStopHour,
        renStopMin: configData.renStopMin,
        renNotifyStartHour: configData.renNotifyStartHour,
        renNotifyStartMin: configData.renNotifyStartMin,
        renNotifyEndHour: configData.renNotifyEndHour,
        renNotifyEndMin: configData.renNotifyEndMin,
      };

      const response = await submitChargingConfig(payload);

      if (response?.statusDescription?.status === 200) {
        Swal.fire({
          icon: "success",
          text:
            response?.statusDescription?.description ||
            "Charging configuration saved successfully!",
        }).then(() => {
          onComplete();
          setActiveTab("fallback");
        });
      } else {
        Swal.fire({
          icon: "error",
          text:
            response?.statusDescription?.description ||
            "Failed to save charging configuration",
        });
      }
    } catch (error) {
      console.error("Error submitting charging configuration:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to save charging configuration",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    {isLoading && <Loader />}
    {/* <div className="tab-content"> */}
      <div className="tab-pane active">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Renewal Retry(Per Day)</label>
              <input
                type="number"
                className="form-control"
                name="renRetry"
                value={configData.renRetry}
                onChange={handleChange}
                placeholder="Enter Renewal Retry"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Renewal Retry Interval</label>
              <div className="d-flex">
                <select
                  className="form-control mr-2"
                  name="renRetryIntervalHour"
                  value={configData.renRetryIntervalHour}
                  onChange={handleChange}
                >
                  {hours.map((hour) => (
                    <option key={hour} value={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  name="renRetryIntervalMin"
                  value={configData.renRetryIntervalMin}
                  onChange={handleChange}
                >
                  {minutes.map((minute) => (
                    <option key={minute} value={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <div className="form-group">
              <label>Renewal Start Time</label>
              <div className="d-flex">
                <select
                  className="form-control mr-2"
                  name="renStartHour"
                  value={configData.renStartHour}
                  onChange={handleChange}
                >
                  {hours.map((hour) => (
                    <option key={hour} value={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  name="renStartMin"
                  value={configData.renStartMin}
                  onChange={handleChange}
                >
                  {minutes.map((minute) => (
                    <option key={minute} value={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Renewal End Time</label>
              <div className="d-flex">
                <select
                  className="form-control mr-2"
                  name="renStopHour"
                  value={configData.renStopHour}
                  onChange={handleChange}
                >
                  {hours.map((hour) => (
                    <option key={hour} value={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  name="renStopMin"
                  value={configData.renStopMin}
                  onChange={handleChange}
                >
                  {minutes.map((minute) => (
                    <option key={minute} value={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <div className="form-group">
              <label>Renewal Notification Start Time</label>
              <div className="d-flex">
                <select
                  className="form-control mr-2"
                  name="renNotifyStartHour"
                  value={configData.renNotifyStartHour}
                  onChange={handleChange}
                >
                  {hours.map((hour) => (
                    <option key={hour} value={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  name="renNotifyStartMin"
                  value={configData.renNotifyStartMin}
                  onChange={handleChange}
                >
                  {minutes.map((minute) => (
                    <option key={minute} value={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Renewal Notification End Time</label>
              <div className="d-flex">
                <select
                  className="form-control mr-2"
                  name="renNotifyEndHour"
                  value={configData.renNotifyEndHour}
                  onChange={handleChange}
                >
                  {hours.map((hour) => (
                    <option key={hour} value={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  name="renNotifyEndMin"
                  value={configData.renNotifyEndMin}
                  onChange={handleChange}
                >
                  {minutes.map((minute) => (
                    <option key={minute} value={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-12 text-right d-flex justify-content-between buttons_divs">
            <div >
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() => setActiveTab("keyword")}
              >
                Previous
              </button>
            </div>
            <div className="">
              <button
                type="button"
                className="btn skip_btn me-3"
                onClick={() => {
                  onComplete();
                  setActiveTab("fallback");
                }}
              >
                Skip
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Save & Continue
              </button>
            </div>

          </div>
        </div>
      </div>
    {/* </div> */}
    </>
  );
}
